import { Context } from 'effect';

import type { TenantIdentity } from '../../config/tenant';
import { ContextTag } from '../context';

export class TenantConfig extends Context.Service<TenantConfig, TenantIdentity>()(
  ContextTag.TenantConfig
) {}
